import { FormField, FormRenderTypes } from "../Shared/Components/FormRenderer";
import { FormRenderGroupTypes } from "../Shared/Components/FormRenderer/FormRenderGroup.types";

export const discountFields: FormField[] = [
	{
		name: "name",
		label: "Nazwa zniżki",
		type: FormRenderTypes.input,
		value: "",
		placeholder: "Nazwa zniżki",
		group: FormRenderGroupTypes.basic,
	},
	{
		name: "startDate",
		label: "Data rozpoczęcia zniżki",
		type: FormRenderTypes.date,
		value: "",
		placeholder: "Data od",
		group: FormRenderGroupTypes.basic,
	},
	{
		name: "endDate",
		label: "Data zakończenia zniżki",
		type: FormRenderTypes.date,
		value: "",
		placeholder: "Data do",
		group: FormRenderGroupTypes.basic,
	},
	{
		name: "discountAmount",
		label: "Kwota zniżki",
		type: FormRenderTypes.number,
		value: "",
		placeholder: "Kwota zniżki",
		group: FormRenderGroupTypes.configuration,
	},
	{
		name: "usePercentage",
		label: "Możliwość użycia procentu",
		type: FormRenderTypes.switch,
		value: "",
		placeholder: "Możliwość użycia procentu",
		group: FormRenderGroupTypes.configuration,
	},
	{
		name: "discountPercentage",
		label: "Procent zniżki",
		type: FormRenderTypes.number,
		value: "",
		placeholder: "Procent zniżki",
		group: FormRenderGroupTypes.configuration,
	},
];
